import {FC, useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {NavLink, useNavigate} from 'react-router-dom'
import {
  clearNewNotificationCount,
  useNewNotificationCount,
  useNotificationsList
} from 'entities/activity/model/notifications'
import {useDialogsUnreadCount} from 'entities/messages/model/dialogs'
import {ChatRequestsList} from 'features/chatRequestsList'
import {NotificationItem} from 'features/notificationItem'
import {displayCount} from 'shared/lib/entity'
import {Badge} from 'shared/ui/badge'
import {Switcher} from 'shared/ui/switcher'
import {bottomMenuList, SidebarKeys} from './config'
import styles from './styles.module.scss'

export const BottomMenu = () => {
  const navigate = useNavigate()
  const unreadMessages = useDialogsUnreadCount()
  const [notificationsIsShowPopup, setNotificationsIsShowPopup] = useState<boolean>(false)
  const newNotificationCount = useNewNotificationCount()

  const onClickHandler = (id: SidebarKeys, to: string) => {
    if (id !== 'notifications') return navigate(to)

    setNotificationsIsShowPopup(!notificationsIsShowPopup)
  }

  const backdropClickHandler = () => setNotificationsIsShowPopup(false)

  return (
    <>
      {notificationsIsShowPopup ? <div className={styles.backdrop} onClick={backdropClickHandler} /> : null}
      <div className={styles.bottomMenu}>
        {bottomMenuList.map(
          ({id, iconActive, iconDefault, key, text, linkTo}) => (
            <NavLink
              className={({isActive}) => `
                ${(notificationsIsShowPopup && id === 'notifications') || isActive ? styles.active : ''}
                ${styles.bottomMenuItem}
              `}
              to={linkTo}
              key={key}
              onClick={(e) => {
                e.preventDefault()
                setNotificationsIsShowPopup(false)
                onClickHandler(id, linkTo)
              }}
            >
              {({isActive}) => (
                <>
                  <div className={styles.bottomMenuItemIcon}>
                    {(notificationsIsShowPopup && id === 'notifications') || isActive ? iconActive : iconDefault}

                    {id === 'notifications' && newNotificationCount
                      ? <Badge type='red' className={styles.bottomMenuItemCounter}>
                        {displayCount(newNotificationCount)}
                      </Badge>
                      : null}

                    {id === 'chats' && unreadMessages
                      ? <Badge type='red' className={styles.bottomMenuItemCounter}>
                        {displayCount(unreadMessages)}
                      </Badge>
                      : null}
                  </div>
                  <span className={styles.bottomMenuItemTitle}>{text}</span>
                </>
              )}
            </NavLink>
          )
        )}
      </div>
      <NotificationsPopup isOpen={notificationsIsShowPopup} onClose={() => setNotificationsIsShowPopup(false)} />
    </>
  )
}

type NotificationsPopupProps = {
  isOpen: boolean
  onClose: () => void
}

const NotificationsPopup: FC<NotificationsPopupProps> = ({isOpen, onClose}) => {
  const dispatch = useDispatch()
  const [switcherValue, setSwitcherValue] = useState(false)

  const onToggleSwitcher = () => setSwitcherValue(!switcherValue)

  useEffect(() => {
    if (isOpen) dispatch(clearNewNotificationCount())
  }, [isOpen])

  if (!isOpen) return <></>

  return (
    <div className={styles.notificationPopover}>
      <Switcher values={['Chat requests', 'Notifications']} value={switcherValue} handler={onToggleSwitcher} />

      {!switcherValue ? <ChatRequestsList /> : null}
      {switcherValue ? <NotificationsList onClose={onClose} /> : null}
    </div>
  )
}

const NotificationsList: FC<{onClose: () => void}> = ({onClose}) => {
  const navigate = useNavigate()
  const list = useNotificationsList()

  const showAllHandler = () => {
    navigate('/notifications')
    onClose()
  }

  if (list.length) {
    return (
      <>
        <div className={`${styles.notificationsList} ${styles.customScroll}`}>
          {list.slice(0, 20).map((notification, index) => <NotificationItem
            key={index}
            className={styles.notificationItem}
            notification={notification}
            isAction={false}
          />)}
        </div>
        <div onClick={showAllHandler} className={styles.notificationsShowAll}>Show All</div>
      </>
    )
  }

  return <div className={styles.notificationsEmpty}>You don't have any notifications yet</div>
}
